import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './sic-stat.css.lit';

/**
 * The SicStat component
 * @element sic-stat
 * @slot heading - sic heading level 7
 * @slot description - plain text
 */
@customElement('sic-stat')
export class SicStat extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="sic-stat">
        <slot name="heading"></slot>
        <slot name="description"></slot>
      </div>
    `;
  }
}
